export default {
  'customListGroup.title': 'Gestionar Grupos de Listas',
};
